import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaginationComponent } from "../pagination/pagination.component";
import { SortableColumnComponent } from "../sortable-column/sortable-column.component";
import { NumberOnlyDirective } from "../_directives/number.directive";
import { OnlyNumberDirective } from '../_directives/only-number.directive';
import {TimeAgoPipe} from 'time-ago-pipe';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';

@NgModule({
  imports: [CommonModule, ImageCropperModule],
  declarations: [PaginationComponent, SortableColumnComponent,NumberOnlyDirective, OnlyNumberDirective,TimeAgoPipe, ImageCropperComponent],
  exports: [PaginationComponent, SortableColumnComponent, CommonModule,NumberOnlyDirective,OnlyNumberDirective,TimeAgoPipe],
  entryComponents: [ImageCropperComponent]
})
export class SharedModule { }


// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/shared/shared.module.ts